import { ProviderType, RedirectOutputType } from './providerTypes'
import { constructDIDProviderUrl } from '@/utils/didHelpers'

export const bankIdNo: ProviderType = {
  id: 'bankIdNo',
  displayName: 'bankId NO',
  showLogo: false,
  showSubmit: false,
  redirectOutput: (): RedirectOutputType => {
    return {
      url: constructDIDProviderUrl(
        {
          provider: 'bankid-no',
          display: 'popup',
          country: 'NO'
        }
      ),
      id: 'bankid-no',
      container: 'iframe',
      containerHeight: 260,
      autoShow: {
        default: false
      }
    }
  }
}
